import i18next from 'i18next';
import Chaplin from 'chaplin';
import $ from 'jquery';

const Extensions = () => {
  Chaplin.Model.prototype.property = function (value, callback) {
    if (this.has(value)) {
      return callback(this.get(value));
    }
  };

  $(document).ajaxError(function (e, xhr) {
    window.postMessage(
      {
        event_type: 'request:failed',
        status: xhr.status,
        location: xhr.getResponseHeader('location'),
      },
      window.location.origin
    );
  });

  /**
   *  Shim fetch to add the language code as an Accept-Language header from i18next
   *    also see app/lib/utils.js for similar jQuery shim
   **/
  window.fetch = (function (original) {
    const ACCEPT_LANG_HEADER = 'Accept-Language';
    return function (...args) {
      if (i18next.language) {
        if (args[1] && args[1].headers) {
          // if a config object with headers is found
          const formatLangString = lang => {
            return lang ? `,${lang}` : '';
          };
          if (args[1].headers instanceof Headers) {
            const acceptLanguage = args[1].headers.get(ACCEPT_LANG_HEADER);
            args[1].headers.set(
              // merge the language code from i18next with the existing Accept-Language header
              ACCEPT_LANG_HEADER,
              `${i18next.language};q=1.0${formatLangString(acceptLanguage)}`
            );
          } else {
            const acceptLanguage = args[1].headers[ACCEPT_LANG_HEADER];
            args[1].headers[ACCEPT_LANG_HEADER] = `${i18next.language};q=1.0${formatLangString(acceptLanguage)}`;
          }
        } else {
          // if no config object is found
          const headers = new Headers();
          headers.set(ACCEPT_LANG_HEADER, `${i18next.language};q=1.0`);
          const config = args[1] ? args[1] : {};
          config.headers = headers;
          const arg = args.shift(); // preserve the first argument
          args.unshift(config); // add new/updated config object
          args.unshift(arg); // restore the first argument so headers is the second argument
        }
      }
      return original.apply(this, args).then(function (response) {
        if (response.status !== undefined && response.status !== 200) {
          window.postMessage(
            {
              event_type: 'request:failed',
              status: response.status,
              location: response.headers.get('location'),
            },
            window.location.origin
          );
        }
        return response;
      });
    };
  })(window.fetch);
};

export default Extensions;
